import styled from 'styled-components';
import { COMMON, FLEX_CONTAINER, LAYOUT } from '../constants';
const Row = styled.div.withConfig({
  displayName: "Row",
  componentId: "chrb89-0"
})(["", ";", ";", ";"], COMMON, FLEX_CONTAINER, LAYOUT);
Row.defaultProps = {
  display: 'flex',
  flexWrap: 'wrap',
  mx: -3
};
Row.propTypes = { ...COMMON.propTypes,
  ...FLEX_CONTAINER.propTypes,
  ...LAYOUT.propTypes
};
Row.displayName = 'Row';
export default Row;